import { State } from 'modules';
import { SearchResultsModel, SearchSuggestionsResultsModel } from 'types';

export const getSearchResults = (state: State): SearchResultsModel =>
  state.models.search.results;

export const getSearchSuggestions = (
  state: State,
): SearchSuggestionsResultsModel => state.models.search.suggestions;

export const getSelectedSuggestion = (state: State): string =>
  state.models.search.selectedSuggestion;

export const getCurrentSearchQuery = (state: State): string =>
  state.models.search.currentQuery;

export const isSearchLoading = (state: State): boolean =>
  state.models.search.isLoading;

export const isSearchError = (state: State): boolean =>
  state.models.search.searchError;

export const isSavedSearchPromoVisible = (state: State): boolean =>
  state.ui.search.displaySavedSearchPromo;

export const isAddSearchFormVisible = (state: State): boolean =>
  state.ui.search.displayAddSavedSearchForm;



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/search.ts